import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children, adminOnly = false, feature = null }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}><div className="spin" /></div>;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(`${location.pathname}${location.search}`)}`} replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/platform" replace />;
  if (feature && !user?.capabilities?.[feature]) return <Navigate to={`/pricing?locked=${feature}`} replace />;
  return children;
}

// ── ScoreCard ──
export function ScoreCard({ icon, label, total, max, band, cefr, gradient }) {
  return (
    <div className="score-card" style={{ background: gradient || 'linear-gradient(135deg,#1e3a5f,#2563eb)' }}>
      <div style={{ fontSize: 12, opacity: 0.8, marginBottom: 5 }}>{icon} {label}</div>
      <div className="score-big">
        {total !== null && total !== undefined ? total : '—'}
        <span className="score-denom">/{max}</span>
      </div>
      {band && <div className="score-band">Band {band}</div>}
      {cefr && <div className="score-cefr">{cefr}</div>}
    </div>
  );
}

// ── CriteriaGrid ──
export function CriteriaGrid({ scores, color = 'var(--nv)' }) {
  const items = [
    ['Content', scores?.content],
    ['Communicative', scores?.communicative],
    ['Organisation', scores?.organisation],
    ['Language', scores?.language],
  ];
  return (
    <div className="criteria-grid">
      {items.map(([label, val]) => (
        <div className="criteria-box" key={label}>
          <div className="criteria-val" style={{ color }}>
            {val ?? '—'}<span style={{ fontSize: 11, fontWeight: 400, color: 'var(--mu)' }}>/5</span>
          </div>
          <div className="criteria-name">{label}</div>
        </div>
      ))}
    </div>
  );
}

// ── SpinnerOverlay ──
export function SpinnerOverlay({ text = 'Loading…' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200, gap: 12, color: 'var(--mu)' }}>
      <div className="spin" />
      <span>{text}</span>
    </div>
  );
}

// ── ResultFeedback ──
export function ResultFeedback({ strengths, improvements, suggestion, color = 'var(--sk)' }) {
  return (
    <div className="result-feedback" style={{ borderLeft: `3px solid ${color}` }}>
      {strengths && <p>✅ <strong>Strengths:</strong> {strengths}</p>}
      {improvements && <p>⚠️ <strong>Improve:</strong> {improvements}</p>}
      {suggestion && <p>💡 <strong>Tip:</strong> {suggestion}</p>}
    </div>
  );
}

// ── InfoPanel ──
export function InfoPanel({ id, children }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <button
        className={`info-btn-light pulse-hint${open ? ' active' : ''}`}
        onClick={() => setOpen(!open)}
      >
        <span>اعرف أكثر ▼</span>
        <i className="info-arrow" style={{ transform: open ? 'rotate(180deg)' : 'none', display: 'inline-block', transition: 'transform .3s' }}>▼</i>
      </button>
      <div className={`info-panel${open ? ' open' : ''}`} style={{ padding: open ? '16px 18px' : 0 }}>
        {children}
      </div>
    </div>
  );
}
